/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper" ;
    const __vue_script__ ={
		name:'filter_tablets_component',
        props: {
            search_filters_prop: {
                default: global.search_filters,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                search_filters:this.search_filters_prop,
			};
		},
        mounted(){
            global.emitter.on("update-search-tablets", args => {
                this.$forceUpdate();
            });
            // search_filters.region='';
            // search_filters.city='';
            // search_filters.district='';
            // search_filters.ad_type='';
            // search_filters.property_type='';
            // search_filters.min_price=0;
            // search_filters.max_price=100;
            // search_filters.price=[0, 0];
            // search_filters.no_bath=0;
            // search_filters.no_bed=0;
            // search_filters.published=-1;
            // search_filters.locked=0;
            // search_filters.status=null;

        },
		methods: {
            remove_filter: function(){
                global.emitter.emit("update-filters");
            },
            age_to_text: function(val){
                return helper.t(val===1?'New':val===2?'LTY':val===13?'10+ Y':`${val-2}`)
            }
		},
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-toolbar",
      staticStyle: { "overflow-x": "auto" },
      attrs: { role: "toolbar", "aria-label": "Toolbar with button groups" }
    },
    [
      _c("div", { staticClass: "btn-group me-2", attrs: { role: "group" } }, [
        _vm.search_filters.region
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.region = ""
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Region: {0}", [
                      _vm.frappe.lang_dir == "ltr"
                        ? _vm.search_filters.region.name_en
                        : _vm.search_filters.region.name_ar
                    ])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.city
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.city = ""
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("City: {0}", [
                      _vm.frappe.lang_dir == "ltr"
                        ? _vm.search_filters.city.name_en
                        : _vm.search_filters.city.name_ar
                    ])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.ad_type
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.ad_type = null
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Ad Type: {0}", [_vm.search_filters.ad_type])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.property_type
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.property_type = null
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Property Type: {0}", [
                      _vm.search_filters.property_type
                    ])
                  )
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group me-2", attrs: { role: "group" } }, [
        _vm.search_filters.capacity[0] > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.capacity[0] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Min Size: {0}", [
                      _vm.search_filters.capacity[0]
                    ])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.capacity[1] > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.capacity[1] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Max Size: {0}", [
                      _vm.search_filters.capacity[1]
                    ])
                  )
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group me-2", attrs: { role: "group" } }, [
        _vm.search_filters.age[0] > 1
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.age[0] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Min age: {0}", [
                      _vm.age_to_text(_vm.search_filters.age[0])
                    ])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.age[1] < 13
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.age[1] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Max age: {0}", [
                      _vm.age_to_text(_vm.search_filters.age[1])
                    ])
                  )
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group me-2", attrs: { role: "group" } }, [
        _vm.search_filters.price[0] > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.price[0] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Min Price: {0}", [
                      _vm.search_filters.price[0]
                    ])
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.price[1] > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.price[1] = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Max Price: {0}", [
                      _vm.search_filters.price[1]
                    ])
                  )
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-group me-2", attrs: { role: "group" } }, [
        _vm.search_filters.no_bed > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.no_bed = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa-solid fa-lg fa-door-closed" }),
                _vm._v(" " + _vm._s(_vm.search_filters.no_bed))
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.search_filters.no_bath > 0
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.search_filters.no_bath = 0
                    _vm.remove_filter()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa-solid fa-lg fa-bath" }),
                _vm._v(" " + _vm._s(_vm.search_filters.no_bath))
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-group me-2", attrs: { role: "group" } },
        _vm._l(_vm.search_filters.features, function(status, feature) {
          return status
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.search_filters.features[feature] = false
                      _vm.remove_filter()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.helper.t(feature)))]
              )
            : _vm._e()
        }),
        0
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6b1cc111_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"filter-tablets-component.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/filter-tablets-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__